var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouriesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1666 22.7653V18.5H30.1666V22.7653C30.1666 25.9401 30.1666 27.5275 29.1903 28.5137C28.214 29.5 26.6426 29.5 23.4999 29.5H21.8333C18.6906 29.5 17.1192 29.5 16.1429 28.5137C15.1666 27.5275 15.1666 25.9401 15.1666 22.7653Z",
    fill: "#6C27FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 22.7653V18.5H30.1666V22.7653C30.1666 25.9401 30.1666 27.5275 29.1903 28.5137C28.214 29.5 26.6426 29.5 23.4999 29.5H21.8333C18.6906 29.5 17.1192 29.5 16.1429 28.5137C15.1666 27.5275 15.1666 25.9401 15.1666 22.7653Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 18.5L15.8878 16.9615C16.4471 15.7684 16.7267 15.1718 17.2935 14.8359C17.8604 14.5 18.5875 14.5 20.0416 14.5H25.2916C26.7458 14.5 27.4728 14.5 28.0397 14.8359C28.6065 15.1718 28.8862 15.7684 29.4454 16.9615L30.1666 18.5",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 21.5H24.1666",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouriesLogo);
export default __webpack_public_path__ + "static/media/couries-logo.6da898531de5734db9d2252c78e2ede0.svg";
export { ForwardRef as ReactComponent };